import { render, staticRenderFns } from "./PlatDataGridSiteUnit.vue?vue&type=template&id=1d4f0228"
import script from "./PlatDataGridSiteUnit.vue?vue&type=script&lang=js"
export * from "./PlatDataGridSiteUnit.vue?vue&type=script&lang=js"
import style0 from "./PlatDataGridSiteUnit.vue?vue&type=style&index=0&id=1d4f0228&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports